import React, { useEffect, useState } from 'react'; 

// Componente para buscar dados de uma API e passá-los para o componente pai
function PegandoDados({ onDataFetched }) {
  // Estado para armazenar os itens recebidos da API
  const [items, setItems] = useState([]);

  // useEffect para buscar dados da API quando o componente é montado ou quando 'onDataFetched' muda
  useEffect(() => {
    // Função assíncrona para buscar dados da API
    const fetchData = async () => {
      try {
        // Faz uma requisição GET para a API
        const response = await fetch('https://dragonball-api.com/api/characters');
        // Converte a resposta para JSON
        const data = await response.json();
        
        // Armazena os itens recebidos no estado
        setItems(data.items || []); 

        // Se a função onDataFetched for fornecida, passa os dados para o componente pai
        if (onDataFetched) {
          onDataFetched(data); 
        }
      } catch (error) {
        // Exibe um erro no console se a requisição falhar
        console.error('Erro ao buscar dados da API:', error);
      }
    };

    // Chama a função fetchData para iniciar a busca de dados
    fetchData();
  }, [onDataFetched]); // useEffect será chamado novamente se 'onDataFetched' mudar

  return (
    <div>
      {}
    </div>
  );
}

export default PegandoDados;
